import { observer } from 'mobx-react-lite';

import { LoadingRigOperations, WellRigOperationStage } from '../../../presets/drilling-wells-chart/entities';
import type { WellsViewSettingsProvider } from '../../../presets/drilling-wells-chart/wells-view-settings-provider';
import type { Viewport } from '../../../shared/viewport/viewport';
import type { ComparingWellsData } from '../../comparing-wells-chart/data';

import { ComparingWellsDataItemFull } from './comparing-wells-data-item-full';

interface Props {
  data: ComparingWellsData.ViewItem[];
  horizontalViewport: Viewport;
  verticalViewport: Viewport;
  viewProvider: WellsViewSettingsProvider;
  onWellStageClick(wellId: number): void;
}

export const ComparingWellsDataItemsFull = observer(function ComparingWellsDataItemsFull({
  data,
  horizontalViewport,
  verticalViewport,
  viewProvider,
  onWellStageClick,
}: Props) {
  return (
    <>
      {data.map((item) => {
        if (item instanceof WellRigOperationStage || item instanceof LoadingRigOperations) {
          return (
            <ComparingWellsDataItemFull
              key={item.getKey()}
              item={item}
              viewProvider={viewProvider}
              horizontalViewport={horizontalViewport}
              verticalViewport={verticalViewport}
              onClick={onWellStageClick}
            />
          );
        }

        return null;
      })}
    </>
  );
});
